const FEMALE_EXCEPTIONS = new Set([
  "nicole", "isabelle", "gabrielle", "daniele", "karine", "eliane", "simone",
  "solange", "celeste", "yolande", "rose", "irene", "jaqueline", "adrienne",
]);

const MALE_ENDING_A = new Set(["luca", "kaua", "joshua", "ezra", "mica"]);

function hashName(name) {
  let h = 0;
  for (let i = 0; i < name.length; i += 1) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return h;
}

export function avatarFor(name) {
  const first = (name || "?").trim().split(/\s+/)[0].toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
  const female =
    FEMALE_EXCEPTIONS.has(first) || (first.endsWith("a") && !MALE_ENDING_A.has(first));
  const n = hashName(first) % 95;
  return `https://randomuser.me/api/portraits/${female ? "women" : "men"}/${n}.jpg`;
}
